<script>
    import Fa from 'svelte-fa';
    import { faList, faGrid2 } from '@fortawesome/pro-solid-svg-icons';

    import { invalidateAll } from '$app/navigation';

    export let classes = '';
    export let currentLayout;

    function toggleLayout() {
        const layout = currentLayout === 'grid' ? '' : 'grid';

        if (layout === 'grid') {
            const cookieWindow = 60 * 60 * 24 * 365;
            document.cookie = `layout=${layout}; max-age=${cookieWindow}; path=/`;
        } else {
            document.cookie = `layout=; max-age=0; path=/`;
        }

        currentLayout = layout;
        invalidateAll();
    }
</script>

<button
    aria-label="Toggle collection list or grid view"
    on:click={toggleLayout}
    class={`relative inline-flex shrink-0 items-center justify-center rounded-full border border-color-text/40 bg-color-background p-2 text-sm lg:ml-0 ${classes}`}
>
    {#if currentLayout === 'grid'}
        <Fa icon={faList} />
    {:else}
        <Fa icon={faGrid2} />
    {/if}
</button>
